<template>
    <div style="position: relative">
        <VTooltip>
            <Image :src="$cdn.url('lol', ['items', gid || blankId], 'png')" :size="Isize" :class="description.includes('Mythic') ? 'mythic-outline' : ''"/>
            <span class="badge counter" v-if="count > 1">{{count}}</span>

            <template #popper>
                <div class="description" v-if="gid">
                    <span class="fw-bold" :style="{fontSize: '14px', color: colors.title}">{{$asset.lol.items[gid].name}}</span>
                    <hr class="my-2">
                    <span>{{description}}</span>
                    <br><br>
                    <span class="text-info fw-bold">Cost: {{$asset.lol.items[gid].priceTotal}}</span>
                </div>
            </template>
        </VTooltip>
    </div>
</template>

<style lang="scss" scoped>
.counter {
    position: absolute;
    right: 0px;
    bottom: 0px;
    border-radius: 50%;
    overflow: hidden;
    padding: 3px 6px;
    background: rgb(242, 255, 0);
    color: black;
    font-weight: 700;
}

.mythic-outline {
    outline: 1px solid rgb(242, 255, 0);
    // outline-offset: -1px;
}

.description {
    white-space: pre-wrap;
    max-width: min(100vw, 500px);
    font-size: 12px;
}
</style>

<script lang="ts">
import { Watch, Prop } from 'vue-property-decorator'
import { Options, Vue } from 'vue-class-component'
import Image from '../Image.vue'

@Options({components: {Image}})
export default class Item extends Vue {

    Isize: number | string = ""
    uuid!: string
    blankId = 7050

    @Prop() readonly gid!: number
    @Prop({default: 0}) readonly count!: number
    @Prop({default: "100%"}) readonly size!: number
    @Prop({default: []}) readonly rSize!: Array<number>

    colors: Record<string, string> = {
        "title": "rgb(0, 223, 126)",
        "attribute": "rgb(0, 223, 201)"
    }

    get winWidth(): number {
        return this.$store.state.winWidth
    }

    get description (): string {
        return this.$asset.lol.items[this.gid || this.blankId].cleanedDescription.replaceAll('\n ', '\n').trim()
    }

    created (): void {
        this.uuid = this.$uuid.uuid1()
        this.getSize(this.winWidth)
    }

    @Watch('winWidth')
    getSize(after: number | string): void {
        if (this.rSize.length == 0)
            this.Isize = this.$css.asDimension(this.size)
        else if (after < 576)
            this.Isize = this.$css.asDimension(this.rSize[0])
        else if (after < 992)
            this.Isize = this.$css.asDimension(this.rSize[1])
        else
            this.Isize = this.$css.asDimension(this.rSize[2])
    }

}
</script>
